// 좌표 목록 → 도로거리/시간 행렬을 받는 Cloud Function `routeMatrix` 클라이언트 래퍼
import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";

export interface RoadMatrix {
  distance: number[][]; // meters, NxN (행 i → 열 j). index 0 = origin
  duration: number[][]; // seconds
  provider: "kakao" | "haversine";
  note?: string;
}

const _callable = httpsCallable<{ points: { lat: number; lng: number }[] }, RoadMatrix>(
  functions,
  "routeMatrix",
);

/** points[0] = 출발점, 나머지 = 방문 노드. 도로거리 행렬을 반환(실패 시 서버가 직선거리로 폴백). */
export async function fetchRoadMatrix(points: { lat: number; lng: number }[]): Promise<RoadMatrix> {
  const res = await _callable({ points });
  return res.data;
}
